// extracted by mini-css-extract-plugin
module.exports = {"submissions-table":"task-history_submissions-table__2dfVj","pagination":"task-history_pagination__35dhH","empty":"task-history_empty__1tjB7"};